type CoachMarkRectLike = Pick<DOMRect, 'left' | 'top' | 'width' | 'height'>;

const DEFAULT_RECT_CHANGE_THRESHOLD_PX = 0.5;

export const hasCoachMarkRectChanged = (
  previous: CoachMarkRectLike | null,
  next: CoachMarkRectLike,
  thresholdPx: number = DEFAULT_RECT_CHANGE_THRESHOLD_PX
): boolean => {
  if (!previous) return true;

  return (
    Math.abs(previous.left - next.left) > thresholdPx
    || Math.abs(previous.top - next.top) > thresholdPx
    || Math.abs(previous.width - next.width) > thresholdPx
    || Math.abs(previous.height - next.height) > thresholdPx
  );
};
